import { AnyApiFactory } from '@backstage/core-plugin-api';
import { defaultApis } from '@platt-internal/backstage-plugin-bootstrap-react';

export const apis: AnyApiFactory[] = [...defaultApis];
